module.exports = __webpack_public_path__ + "img/calc_512_red.5e5145ba.png";